const { LIST_CUSTOM_LOGIN_USERS } = require('../Constants/customLoginUsers.constants');

const initalState = {
    error: {
        code: '',
        message: ''
    },
    customLoginUsersData: [],
};

export default (state = initalState, action) => {
  switch (action.type) {
    case LIST_CUSTOM_LOGIN_USERS:
      return {
        ...state,
        customLoginUsersData: action.data.map(
          item => item.userEmail
        ),
      }
    default:
        return state;
  }
};
